export default "__VITE_ASSET__DP6gFWJR__"